import styled from '@emotion/styled'

import { breakpoint } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { metrics } from '../../__styling/settings/metrics'
import { supports } from '../../__helpers/at-supports-helper'
import { themedValue } from '../../__styling/themed-value'
import { withClass } from '@news-mono/web-common'
import { ThemeMargins, ContainerWidth } from '../../__styling/settings/metrics'
import { SidebarOptions } from './Athena'

export interface AthenaProps {
    sidebarOptions: SidebarOptions
    verticalSpacing?: keyof ThemeMargins
    containerWidth?: ContainerWidth
}

const sidebarWidth = 300
const gridGapSize = calcRem(21)

export const StyledAthena = styled('div')<AthenaProps>(
    ({ theme, verticalSpacing, containerWidth, sidebarOptions }) => ({
        margin: '0 auto',
        width: '100%',
        padding: theme.margins.outerMargin,
        marginBottom:
            verticalSpacing &&
            calcRem(metrics[theme.kind].margins[verticalSpacing]),
        maxWidth: containerWidth,
        display: 'grid',
        gridTemplateColumns: '100%',
        gridGap: sidebarOptions === 'visibleMobile' ? 0 : gridGapSize,

        [breakpoint(sidebarOptions === 'visibleMobile' ? 'sm' : 'md')]: {
            // prettier-ignore
            gridTemplateColumns: `minmax(0,1fr) ${calcRem(sidebarWidth)}`,
            gridGap: gridGapSize,
        },
    }),
)

export const StyledMain = styled('div')({
    [breakpoint('md')]: {
        padding: calcRem(0, metrics.thewest.margins.lg),
    },
})

export const StyledMainArticle = StyledMain.withComponent('article')

export interface SidebarProps {
    sidebarOptions: SidebarOptions
}

// prettier-ignore
export const StyledSidebar = withClass('hide-print')(styled('aside')<SidebarProps>(({ sidebarOptions, theme }) =>
    ({
        display: sidebarOptions === 'visibleMobile' ? 'block' : 'none',

        [breakpoint(sidebarOptions === 'visibleMobile' ? 'sm' : 'md')]: {
            boxSizing: 'content-box',
            display: 'block'
        },
    })
))
